module.exports = __webpack_public_path__ + "static/media/help-icon.b3e4a030.png";